/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const _pagepath = '/seminar/';

	const introductionSlide = () => {
		const introductionSlider = document.querySelector(".mod-introductionSlide");
		if (introductionSlider) {
			const slideItems = introductionSlider.querySelectorAll(".splide__slide");
	
			const splide = new Splide(".mod-introductionSlide.splide", {
				type: "loop",
				perPage: 1,
				autoplay: false,
				interval: 5000,
				speed: 500,
				arrows: slideItems.length > 1, // スライドが1つなら矢印を非表示
				pagination: true,
				paginationKeyboard: true,
			}).mount();
		}
	};

	const caseTagInsert = () => {
		const getJSONfiles = () => '/ajax/news/list.json';
	
		const insertTags = (data) => {
			const items = document.querySelectorAll('.rt_key');
	
			items.forEach(item => {
				const rtKeyValue = item.textContent.trim(); // rt_key の値を取得
	
				const matchedData = data.rt_bn_news_list.find(news => {
					return news._key === rtKeyValue; // JSON の _key と一致するかチェック
				});
	
				if (matchedData) {
					const tagElement = item
						.closest(".__item")
						.querySelector(".js-caseTag");
					if (tagElement) {
						// cf_n_related_solutions 内の cf_nt_name_d を全て取得し、#で連結
						const relatedSolutions = matchedData.cf_n_related_solutions.map(
							(solution) => `${solution.cf_nt_name_d}`
						).join(" ");
						
						// タグ要素に設定
						tagElement.textContent = relatedSolutions;
					}
				}
			});
		};
	
		fetch(getJSONfiles())
			.then(response => {
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			})
			.then(data => {
				insertTags(data);
			})
			.catch(error => {
				console.error('Error fetching JSON data:', error);
			});
	};

	introductionSlide();
	caseTagInsert();


})(window.FUNCTIONS);
